import { GeoCalculationsService } from "./geoCalculations.service";
import { api } from "../../apiProvider";
import GeoCalculationItem from "../../../geocalc/dto/GeoCalculationItem";
import Item from "../../../layers/dto/Item";

export const geoCalculationsAdapter: GeoCalculationsService = async () => {
    const resp = await api.geoCalculations();
    const calculations = resp.data.map(
        (calculation: { calculationId: number; calculationName: string }) =>
            new GeoCalculationItem(
                new Item(calculation.calculationId, calculation.calculationName, true, false, false, true)
            )
    );
    return calculations as GeoCalculationItem[];
};
